import useChatConnections from 'hooks/redux/useChatConnections'
import React from 'react'
import ChatMessages from '../ChatMessages'
import { useUnreadMessages } from '../ChatMessages/useUnreadMessages'
import styles from './ActiveChatMessageView.module.scss'

interface Props {
    isExpanded?: boolean
}

const ActiveChatMessageView: React.FC<Props> = ({ isExpanded }) => {
    const { messages, isTyping, unread, id, isAttachmentUploading } = useChatConnections('selected')!

    const { messagesContainer } = useUnreadMessages(id, messages, isTyping)

    return (
        <>
            <ChatMessages
                ref={messagesContainer}
                messages={messages ?? []}
                unread={unread}
                isTyping={isTyping}
                isExpanded={isExpanded}
            />
            {isAttachmentUploading ? (
                <div className={styles.attachmentStatusWapper}>
                    Attachment is being uploaded…
                </div>
            ) : null}
        </>
    )
}

export default ActiveChatMessageView
